import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services';
import { IMG_BASE_URL } from '../Helpers';
import { useApp } from '../AppContext';
import BookGrid from './BookGrid';

export default function BookList() {
    const { setBooks, books } = useApp();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState('All');
    const fetchBooks = async () => {
        try {
            const booksData = await api("GET", "books");
            console.log(booksData)
            setBooks(booksData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (books.length === 0) {
            fetchBooks();
        }
    }, []);
    const categories = ['All', ...new Set(books.map(book => book.category_name).filter(Boolean))];

    const filteredBooks = selectedCategory === 'All'
        ? books
        : books.filter((book) => book.category_name === selectedCategory);
    return (
        <section className="">
            <div className="container px-4 px-lg-5 mt-5">
                <div className="row mb-5 primary-bottom-border">
                    <div className="col-md-3 col-sm-6 col-10">
                        <div className="form-group">
                            <select
                                className="form-select custom-category-dropdown"
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                            >
                                {categories.map((category, index) => (
                                    <option key={index} value={category}>
                                        {category === 'All' ? 'All Categories' : category}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                    {filteredBooks.map((item, index) => (
                        <>
                            <BookGrid key={index}
                                books={item}
                                onViewBook={(book) => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    navigate('/book-details', { state: { book } });
                                }}
                            />
                        </>
                    ))}
                </div>
            </div>
        </section>
    )
}
